import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Row, Col, Image } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import Axios from "axios";

//ACTIONS
import * as AccessModalActions from "../../../envStore/actions/accessModal";
import * as UserActions from "../../../../store/actions/user";

//STYLES
import * as navBarStyles from "./styles/mobileNavBar";

//NAV METHODS
import pageNavigation from "./navBarClickMethods";

//IMAGES
import logo from "./images/logo.jpg";

function MobileNavBar() {
    const dispatch = useDispatch();
    const [menuOpen, setMenuOpen] = useState(false);
    const [servicesSubMenuOpen, setServicesSubMenuOpen] = useState(false);
    const [profileSubMenu, setProfileSubMenu] = useState(false);

    const GS_generalSettings = useSelector((state) => state.GS_generalSettings);
    const user = useSelector((state) => state.user);
    const printingShop = useSelector((state) => state.printingShop);

    const navigate = useNavigate();

    function toggleMainMenu() {
        setMenuOpen(!menuOpen);
    }

    function toggleServicesMenu() {
        setServicesSubMenuOpen(!servicesSubMenuOpen);
    }

    function pageLinkClick(pageTitle) {
        setMenuOpen(false);
        pageNavigation(pageTitle, navigate);
    }

    function handleSignIn() {
        const actions = { action: "getBasket", data: {} };
        dispatch(AccessModalActions.LogActionsAndSignIn(actions));
    }

    function handleYourProfileClick() {
        setProfileSubMenu(false);
        navigate("./profile/overview/orders");
    }

    function handleSignOutClick() {
        setProfileSubMenu(false);
        Axios.post("/userLogin/logout")
            .then((res) => {
                const data = res.data;
                console.log(data);
                if (data.message === "User logged out") {
                    dispatch(UserActions.UpdateAuth(false));
                    dispatch(UserActions.UpdateID(""));
                    dispatch(UserActions.UpdateName(""));
                    dispatch(UserActions.UpdateEmail(""));
                    dispatch(UserActions.UpdateType(""));

                    dispatch(AccessModalActions.SignOutMethod("clearBasketInferface"));

                    navigate("./");
                }
            })
            .catch((err) => {
                console.log(err);
            });
    }

    function handleToggleProfileSubMenu() {
        setProfileSubMenu(!profileSubMenu);
    }

    function handleCloseProfileSubMenu() {
        setProfileSubMenu(false);
    }

    function handleCartOnClick() {
        navigate("./basket");
    }

    return (
        <div style={navBarStyles.body}>
            <Row>
                <Col sm={"auto"} style={navBarStyles.imageContainer} onClick={pageLinkClick.bind(this, "/")}>
                    <Image src={logo} style={navBarStyles.imageSize} />
                </Col>
                <Col style={navBarStyles.navTitle}>
                    High-View Studios <br /> Shop
                </Col>
                <Col sm="auto" style={navBarStyles.navButtons}>
                    {user.auth ? (
                        <div style={navBarStyles.navbarSignedIn}>
                            <div style={navBarStyles.basket}>
                                <i onClick={handleCartOnClick} className="fa-solid fa-cart-shopping"></i>
                                {printingShop.basketItemTotal}
                            </div>
                            <div style={navBarStyles.profileButtons} onClick={handleToggleProfileSubMenu}>
                                <i className="fa-regular fa-circle-user"></i>
                            </div>
                        </div>
                    ) : (
                        <div onClick={handleSignIn}>
                            Sign in &gt; <i className="fa-regular fa-user fa-lg"></i>
                        </div>
                    )}
                </Col>
            </Row>
            {profileSubMenu && (
                <div style={navBarStyles.subNavStyle}>
                    <div style={navBarStyles.subMenuButton} onClick={handleYourProfileClick}>
                        Your Profile
                    </div>
                    <hr style={navBarStyles.lineSetparator} />
                    <div style={navBarStyles.subMenuButton} onClick={handleSignOutClick}>
                        Sign Out
                    </div>
                </div>
            )}
            {/* <Row>
                <Col className="customCSS-nav-link" onClick={toggleMainMenu}>
                    Main Menu
                </Col>
            </Row>
            {menuOpen ? (
                <div>
                    <Row>
                        <Col className="customCSS-nav-link" onClick={pageLinkClick.bind(this, "/")}>
                            Home
                        </Col>
                    </Row>
                    <Row>
                        <Col className="customCSS-nav-link" onClick={pageLinkClick.bind(this, "about")}>
                            About
                        </Col>
                    </Row>
                    <Row>
                        <Col className="customCSS-nav-link" onClick={toggleServicesMenu}>
                            Services
                        </Col>
                    </Row>
                    {servicesSubMenuOpen ? (
                        <div>
                            <Row>
                                <Col className="customCSS-sub-nav-link" onClick={pageLinkClick.bind(this, "3dPrintingService")}>
                                    3D Printing Service
                                </Col>
                            </Row>
                            <Row>
                                <Col className="customCSS-sub-nav-link" onClick={pageLinkClick.bind(this, "webDevelopment")}>
                                    Web Development
                                </Col>
                            </Row>
                            <Row>
                                <Col className="customCSS-sub-nav-link" onClick={pageLinkClick.bind(this, "appDevelopment")}>
                                    App Development
                                </Col>
                            </Row>
                            <Row>
                                <Col className="customCSS-sub-nav-link" onClick={openMySTAFFBookings}>
                                    My STAFF Bookings
                                </Col>
                            </Row>
                        </div>
                    ) : null}
                    <Row>
                        <Col className="customCSS-nav-link" onClick={pageLinkClick.bind(this, "viewHelp")}>
                            ViewHelp
                        </Col>
                    </Row>
                    {GS_generalSettings.mainContactPageVisible && (
                        <Col className="customCSS-nav-link" onClick={pageLinkClick.bind(this, "contactUs")}>
                            Contact Us
                        </Col>
                    )}
                </div>
            ) : null} */}
        </div>
    );
}

export default MobileNavBar;
